import React from 'react';

import { Svg } from '@lglp/components';

const Pin: React.FC<PinProps> = (props) => {
  return (
    <Svg width="10" height="17" {...props}>
      <path
        fill="#0079BE"
        fillRule="evenodd"
        d="M5.149.471c2.323 0 4.206 1.882 4.206 4.206 0 2.322-4.206 11.853-4.206 11.853S.943 6.999.943 4.677C.943 2.353 2.827.471 5.149.471z"
      />
    </Svg>
  );
};

type PinProps = {
  className?: string;
};

export default Pin;
